import CompetencyRequirement from './CompetencyRequirements';
export default CompetencyRequirement;